import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

export const PIPELINE_STAGE_COLORS = {
  submitted: '#63B3ED',
  under_review: '#E9C46A',
  approved: '#67C587',
  funded: '#63D5C8',
};

export const PIPELINE_STAGE_LABELS = {
  submitted: 'Submitted',
  under_review: 'Under Review',
  approved: 'Approved',
  funded: 'Funded',
};

const PipelineStageStatusCard = ({ pipelineStageData = [], totalApplications = 0 }) => {
  const chartData = pipelineStageData
    .filter((item) => item.value > 0)
    .map((item) => ({
      name: item.label,
      value: item.value,
      fill: item.color,
      key: item.key,
    }));

  const total = totalApplications || pipelineStageData.reduce((sum, item) => sum + item.value, 0);

  return (
    <article className="fg-chart-card" data-testid="pipeline-stage-status-card">
      <div className="fg-chart-head">
        <div>
          <h3>Pipeline Stage Status</h3>
          <p className="fg-chart-subtitle">Current application stage distribution for this selected client.</p>
        </div>
        <span className="fg-mini-pill">Selected client</span>
      </div>
      {chartData.length === 0 ? (
        <p className="text-sm text-[var(--fg-muted)]">No applications yet.</p>
      ) : (
        <div className="fg-pipeline-content">
          <div className="fg-pipeline-donut-chart relative h-[140px] w-[140px] shrink-0">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={chartData} dataKey="value" innerRadius={50} outerRadius={68} paddingAngle={2} strokeWidth={0}>
                  {chartData.map((entry) => (
                    <Cell key={entry.key} fill={entry.fill} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="funding-donut-center">
              <strong data-testid="pipeline-stage-total">{total}</strong>
              <small>Applications</small>
            </div>
          </div>
          <div className="fg-legend" data-testid="pipeline-stage-legend">
            {pipelineStageData.map((item) => (
              <div key={item.key} className="fg-legend-row">
                <span className="fg-dot" style={{ background: item.color }} />
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </div>
            ))}
          </div>
        </div>
      )}
    </article>
  );
};

export default PipelineStageStatusCard;
